export default "__VITE_ASSET__BSkx_SH1__"